import React from 'react'

const PasajerosMenorForm = ({ index, data, onChange, tiposDeDocumento, puntosEmbarque }) => {
  return (
    <div className="border border-orange-500 rounded-lg p-4 shadow-sm">
    <h3 className="text-lg font-semibold text-orange-600 mb-4">
      Pasajero {index + 1} - Menor
    </h3>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
    <div className="flex flex-col min-w-0">
    <label className="text-sm text-gray-700 mb-1">Ingrese nombre</label>
      <input
        type="text"
        placeholder="Nombre"
        value={data.nombre}
        onChange={(e) => onChange(index, "nombre", e.target.value)}
        className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
      />
      </div>
      <div className="flex flex-col min-w-0">
      <label className="text-sm text-gray-700 mb-1">Ingrese apellido </label>
      <input
        type="text"
        placeholder="Apellido"
        value={data.apellido}
        onChange={(e) => onChange(index, "apellido", e.target.value)}
        className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
      />
      </div>
      <div className="flex flex-col min-w-0">
      <label className="text-sm text-gray-700 mb-1">Ingrese tipo de documento </label>
<select
          name="idTipoDocumento"
          value={data.idTipoDocumento}
          onChange={(e) => onChange(index, "idTipoDocumento", e.target.value)}
          className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
          style={{ height: "60px" }}
        >
          <option disabled value="">
            Tipo Documento
          </option>
          {tiposDeDocumento?.map((tipo) => (
            <option key={tipo.id} value={tipo.id}>
              {tipo.descripcion}
            </option>
          ))}
        </select>
</div>
          
<div className="flex flex-col min-w-0">
<label className="text-sm text-gray-700 mb-1">Ingrese numero de documento</label>
        <input
          type="text"
          placeholder="Documento"
          value={data.numeroDoc}
          onChange={(e) => onChange(index, "numeroDoc", e.target.value)}
          className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
        />
</div>


<div className="flex flex-col min-w-0">
<label className="text-sm text-gray-700 mb-1">Ingrese sexo </label>
        <select
          name="sexo"
          value={data.sexo}
          onChange={(e) => onChange(index, "sexo", e.target.value)}
          className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
          style={{ height: "60px" }}
        >
          <option disabled value="">
           Seleccione Sexo
          </option>
          <option value="M">
          Masculino
          </option>
          <option value="F">
          Femenino
          </option>
         
        </select>
</div>

       {puntosEmbarque.length > 0 &&
        <div className="flex flex-col min-w-0">
        <label className="text-sm text-gray-700 mb-1">Ingrese punto de embarque</label>
        <select
          name="ideventosEmbarques"
          value={data.ideventosEmbarques}
          onChange={(e) => onChange(index, "ideventosEmbarques", e.target.value)}
          className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
          style={{ height: "60px" }}
        >
          <option disabled value="">
           Seleccione Embarque
          </option>
          {puntosEmbarque?.map((punto) => (
            <option key={punto.id} value={punto.ideventosEmbarques}>
              {punto.direccionFull}
            </option>
          ))}
         
        </select>
</div>
}

  <div className="flex flex-col min-w-0">
  <label className="text-sm text-gray-700 mb-1">Ingrese fecha de nacimiento </label>
      <input
        type="date"
        value={data.fechaNacimiento}
        onChange={(e) => onChange(index, "fechaNacimiento", e.target.value)}
        className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
      />

       </div>
       <div className="flex flex-col min-w-0">
       <label className="text-sm text-gray-700 mb-1">Ingrese edad</label>
      <input
        type="text"
        placeholder="Edad"
        value={data.edad}
        onChange={(e) => onChange(index, "edad", e.target.value)}
        className="border rounded px-3 py-2 w-full focus:ring-2 focus:ring-orange-400"
      />
      </div>
    </div>
  </div>
  )
}

export default PasajerosMenorForm;